import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { INSTALLER_OFFER_OID } from '../shared/injectionTokens';
import { BobHttpService } from '../shared/services/bob-http.service';

import { LegalDocumentUserApproval } from './services/api/GetApprovedDocumentApiResult';
import { LegalDocument } from './services/api/GetToApproveDocumentApiResult';

const LEGAL_DOCUMENT_ENDPOINT = '/legaldocs-api/public/v1/userapproval/documents';

@Injectable({ providedIn: 'root' })
export class LegalDocumentsGateway {
    private readonly http = inject(BobHttpService);
    private readonly offerOID = inject(INSTALLER_OFFER_OID);

    getApprovals(countryCode: string): Promise<LegalDocumentUserApproval[]> {
        return this.getResults('approved', countryCode);
    }

    getDocumentsToApprove(countryCode: string): Promise<LegalDocument[]> {
        return this.getResults('toapprove', countryCode);
    }

    async approve(countryCode: string): Promise<void> {
        await firstValueFrom(
            this.http.post(`${LEGAL_DOCUMENT_ENDPOINT}/approve`, { signatureType: 'simple' }, this.params(countryCode)),
        );
    }

    private async getResults<T>(path: string, countryCode: string): Promise<T[]> {
        const response = await firstValueFrom<{ results: T[] }>(
            this.http.get(`${LEGAL_DOCUMENT_ENDPOINT}/${path}`, this.params(countryCode)),
        );
        return response.results;
    }

    private params(countryCode: string) {
        return { offerOID: this.offerOID, countryCode };
    }
}
